// English UI text (British spelling). Same keys as da.ts – a missing or extra key is a compile error.
import type { da } from './da';

export const en: Record<keyof typeof da, string> = {
  'app.name': 'Mekaniko',

  'aria.map': 'Map',
  'aria.howTo': 'Show me how',
  'aria.hint': 'Help',
  'aria.start': 'Start',
  'aria.rotateLeft': 'Turn left',
  'aria.rotateRight': 'Turn right',
  'aria.remove': 'Remove',
  'aria.switchPlayer': 'Change player',
  'aria.retry': 'Try again',
  'aria.nextLevel': 'Next level',
  'aria.credits': 'Credits',
  'aria.ok': 'OK',
  'aria.back': 'Back',
  'aria.close': 'Close',
  'aria.playWorld': 'Play',
  'aria.player': 'Player {n}',
  'aria.newPlayer': 'New player',
  'aria.changeClothes': 'Change clothes',
  'aria.level': 'Level {n}',

  'gate.adults': 'For grown-ups',
  'gate.help': 'For grown-ups: pick the right answer',

  'parent.title': 'Parents & teachers',
  'parent.intro': 'Mekaniko builds technical understanding: children build, test and adjust little machines. It is the same design process that science and technology lessons in the first years of school are built around.',
  'parent.progress': 'Progress',
  'parent.player': 'Player',
  'parent.stars': 'Stars',
  'parent.levels': 'Levels',
  'parent.ducks': 'Ducks',
  'parent.none': 'No players yet.',
  'parent.reset': 'Delete player',
  'parent.goalsTitle': 'What the game teaches',
  'parent.goalsNote': 'Linked to the Danish national curriculum for science and technology (end of year 2): “explore how simple everyday mechanisms work” and “take part in design processes”. A green tick means your child has completed a level on that topic.',
  'parent.settings': 'Settings',
  'parent.hintAlways': 'Always show the help button',
  'parent.hintAlwaysNote': 'Otherwise it appears after your child has tried 3 times without success.',
  'parent.sound': 'Sound effects',
  'parent.music': 'Music',
  'parent.language': 'Language',
  'parent.testAll': 'Test mode: all levels open',
  'parent.testAllNote': 'For developers — turn it off again before showing the game to others.',
  'parent.credits': 'Credits',
  'parent.buyTitle': 'The full game',
  'parent.buyText': 'The first 3 levels are free. Pay once to unlock every level and world. No adverts, no in-game purchases.',
  'parent.buyBtn': 'Unlock (demo)',
  'parent.bought': 'Unlocked ✓',
  'parent.buyNote': 'Prototype: no real purchase takes place.',

  'goal.gravity': 'Gravity: things fall and roll downhill',
  'goal.ramp': 'Slopes and ramps',
  'goal.direction': 'A force can change direction',
  'goal.spring': 'Springs and bounce',
  'goal.lever': 'Levers (seesaws)',
  'goal.friction': 'Friction: surfaces slow things down',
  'goal.materials': 'What materials are like',
  'goal.energy': 'Energy changes form (fall → bounce)',
  'goal.mechanism': 'Simple everyday mechanisms',
  'goal.chain_reaction': 'Cause and effect (chain reactions)',
  'goal.counting': 'Counting and numbers (maths)',
  'goal.pulley': 'Pulleys and lifting',
  'goal.weight': 'Heavy and light (mass)',

  'credits.map': 'The map',
  'credits.music': 'Music',
  'credits.note': 'The music comes from Pixabay. Thank you to the artists!',
  'credits.thanks': 'Thanks to',
};
